(() => {
  const init = async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cfg = JSON.parse(root.querySelector('[data-cf-config]').textContent);
    if (typeof cfg.product === 'string' && /^[a-z0-9-]+$/.test(cfg.product)) {
      try {
        const response = await fetch('/products/'+cfg.product+'.js', {signal:AbortSignal.timeout(15000)});
        cfg.product = response.ok ? await response.json() : null;
      } catch(error) {cfg.product=null;}
    }
    const t = cfg.text;
    const find = s => root.querySelector(s);
    const form = find('[data-cf-form]');
    const money = n => '$' + Math.round(n).toLocaleString('es-CL');
    const uid = () => 'CF-' + crypto.randomUUID();
    const dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open('crealis-figuras-v1', 1);
      request.onupgradeneeded = () => request.result.createObjectStore('drafts');
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
    dbPromise.catch(() => {});
    const defaults = () => ({id:uid(),format:cfg.line === 'mascota' ? 'mascota' : 'busto',size:cfg.line === 'mascota' ? '12' : '12',base:'sin',base_name:'',subject:'',details:'',date:'',custom_size:'',contact:'',phone:'',photos_later:false,special:false,consent:false,photos:[],step:0,submitted:null});
    let state = defaults();
    let busy = false;
    let processing = false;
    let saveChain = Promise.resolve();
    let changeVersion = 0;
    const status = message => { find('[data-cf-status]').textContent = message; };
    async function readDraft() {
      const db = await dbPromise;
      return new Promise((resolve,reject) => {
        const r = db.transaction('drafts').objectStore('drafts').get(cfg.line);
        r.onsuccess = () => resolve(r.result); r.onerror = () => reject(r.error);
      });
    }
    function save() {
      const snapshot = structuredClone(state);
      snapshot.updated = Date.now();
      saveChain = saveChain.catch(() => {}).then(async () => {
        const db = await dbPromise;
        await new Promise((resolve,reject) => {
          const tr = db.transaction('drafts','readwrite');
          tr.objectStore('drafts').put(snapshot,cfg.line);
          tr.oncomplete = resolve; tr.onerror = () => reject(tr.error);
        });
      }).catch(() => status(t.save_error));
      return saveChain;
    }
    const formats = cfg.line === 'mascota' ? {mascota:'Una mascota',duo:'Dos mascotas',conjunto:'Persona y mascota'} : {busto:'Busto',completo:'Cuerpo completo',pareja:'Pareja',conjunto:'Persona y mascota'};
    const basePrices = cfg.line === 'mascota' ? {'12':9990,'16':14990,'22':22990} : {busto:14990,'15':14990,'20':23990,pareja:39990};
    function sizes() {
      if (cfg.line === 'mascota') return ['12','16','22','otro'];
      if (state.format === 'busto') return ['12','otro'];
      if (state.format === 'completo') return ['15','20','otro'];
      return ['otro'];
    }
    function shared() { return ['duo','pareja','conjunto'].includes(state.format); }
    function quoteOnly() { return state.size === 'otro' || state.special || ['duo','conjunto'].includes(state.format) || (cfg.line === 'persona' && !cfg.personCheckout); }
    function option() {
      if (cfg.line === 'mascota') return state.size + ' cm';
      if (state.format === 'busto') return 'Busto 12 cm';
      if (state.format === 'pareja') return 'Pareja 15 cm';
      return 'Cuerpo completo ' + state.size + ' cm';
    }
    function variant() { return cfg.product?.variants?.find(v => v.option1 === option() && v.option2 === (state.format === 'pareja' ? 'Base compartida' : state.base === 'con' ? 'Con base y nombre' : 'Sin base')); }
    function estimated() {
      if (state.size === 'otro' || ['duo','conjunto'].includes(state.format)) return null;
      let price = cfg.line === 'mascota' ? basePrices[state.size] : basePrices[state.format] || basePrices[state.size];
      return price + (state.base === 'con' && !shared() ? 2990 : 0);
    }
    function actualPrice() { const v=variant(); return !quoteOnly() && v ? v.price/100 : estimated(); }
    const fieldValue = name => state[name] || '';
    const fields = ['base_name','subject','details','date','custom_size','contact','phone'];
    function syncInputs() {
      fields.forEach(n => { form.elements[n].value = fieldValue(n); });
      ['format','base'].forEach(n => { for (const el of form.querySelectorAll('input[name="'+n+'"]')) el.checked = el.value === state[n]; });
      ['photos_later','special','consent'].forEach(n => { form.elements[n].checked = !!state[n]; });
    }
    function summary(includeContact = true) {
      const parts = ['Encargo: '+state.id,formats[state.format]+' · '+(state.subject || 'Desde mis fotografías'),t.size_label+': '+(state.size === 'otro' ? state.custom_size : state.size+' cm'),t.base_label+': '+(shared() ? t.base_included : state.base === 'con' ? t.base_yes+' (+$2.990)' : t.base_none)];
      if (state.base_name && (shared() || state.base === 'con')) parts.push('Nombre en base: '+state.base_name);
      parts.push(t.white);
      if (state.details) parts.push('Detalles: '+state.details);
      if (state.special) parts.push('Composición especial: cotizar antes de pagar');
      if (state.date) parts.push('Fecha deseada (a confirmar): '+state.date);
      parts.push('Fotos: '+state.photos.length+(state.photos_later ? ' · '+t.photo_pending : ' adjuntas'));
      const price=actualPrice();
      parts.push((quoteOnly() || cfg.line === 'persona' ? t.reference : t.estimate)+': '+(price ? money(price) : t.quote_value));
      parts.push(t.approval);
      if (includeContact) parts.push('Contacto: '+state.contact+' · '+state.phone);
      return parts.join('\n');
    }
    function renderSizes() {
      const wrap=find('[data-cf-sizes]'); wrap.replaceChildren();
      if (!sizes().includes(state.size)) state.size=sizes()[0];
      for(const value of sizes()) {
        const label=document.createElement('label'); label.className='cf-choice';
        const input=document.createElement('input'); Object.assign(input,{type:'radio',name:'size',value,checked:value === state.size});
        const span=document.createElement('span'), strong=document.createElement('strong'),small=document.createElement('small');
        strong.textContent=value === 'otro' ? 'Otro tamaño' : value+' cm';
        let price=cfg.line === 'mascota' ? basePrices[value] : basePrices[state.format] || basePrices[value];
        small.textContent=value === 'otro' || ['duo','conjunto'].includes(state.format) ? t.quote_value : (cfg.line === 'persona' ? 'Desde ' : '')+money(price);
        span.append(strong,small);label.append(input,span);wrap.append(label);
      }
    }
    function renderPhotos() {
      const wrap=find('[data-cf-photos]');wrap.replaceChildren();
      state.photos.forEach((photo,i) => {
        const fig=document.createElement('figure');fig.className='cf-photo';
        const img=document.createElement('img');img.src=photo.data;img.alt='Foto de referencia '+(i+1);
        const caption=document.createElement('figcaption');caption.textContent=photo.name;
        const remove=document.createElement('button');remove.type='button';remove.textContent=t.remove;remove.setAttribute('aria-label',t.remove+' '+(i+1));remove.disabled=busy;
        remove.addEventListener('click',() => { state.photos.splice(i,1);changed();renderPhotos(); });
        fig.append(img,caption,remove);wrap.append(fig);
      });
      find('[data-cf-photo-count]').textContent=t.photo_count+': '+state.photos.length+'/3';
    }
    function render() {
      find('[data-cf-custom]').hidden=state.size !== 'otro';
      find('[data-cf-base]').hidden=shared();find('[data-cf-shared-base]').hidden=!shared();
      find('[data-cf-base-name]').hidden=!shared() && state.base !== 'con';
      find('[data-cf-photo-guide]').textContent=cfg.line === 'mascota' && state.format !== 'conjunto' ? t.photo_guide_pet : state.format === 'busto' ? t.photo_guide_bust : t.photo_guide_full;
      const plate=find('[data-cf-nameplate]'); plate.hidden=state.base !== 'con' && !shared();plate.textContent=state.base_name || t.base_preview;
      const image=find('[data-cf-preview]');
      const number=cfg.line === 'mascota' ? (shared() ? 3 : state.base === 'con' ? 2 : 1) : (state.format === 'busto' ? 1 : state.format === 'completo' ? 2 : 3);
      image.src=image.src.replace(/ejemplo-\d/, 'ejemplo-'+number);
      const list=find('[data-cf-summary]');list.replaceChildren();
      for(const [label,value] of [['Figura',formats[state.format]],[t.size_label,state.size === 'otro' ? state.custom_size || 'Otro tamaño' : state.size+' cm'],[t.base_label,shared() ? t.base_included : state.base === 'con' ? t.base_yes : t.base_none]]) {
        const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;list.append(dt,dd);
      }
      const price=actualPrice();find('[data-cf-price]').textContent=price ? money(price) : t.quote_value;
      find('[data-cf-price-label]').textContent=quoteOnly() || cfg.line === 'persona' ? t.reference : t.estimate;
      find('[data-cf-price-note]').textContent=cfg.line === 'persona' ? t.person_price_note : t.price_note;
      find('[data-cf-review]').textContent=summary(false);
      const guide=find('[data-cf-guide]');
      if(guide) {
        find('[data-cf-guide-title]').textContent=[t.guide_one,t.guide_two,t.guide_three][state.step];
        const name=(state.subject || state.base_name).trim();
        let message=state.step === 0 ? t.guide_name : state.step === 1 ? t.guide_photos : t.guide_name_ready;
        if(state.step === 0 && name) message=name+': '+(cfg.line === 'mascota' ? 'ya estamos imaginando su figura.' : 'su historia va tomando forma.');
        if(state.step === 1 && state.photos.length) message=t.photo_progress.replace('{count}',state.photos.length);
        if(state.step === 1 && state.photos_later) message=t.guide_later;
        if(state.step === 2 && name) message=name+': '+t.guide_name_ready;
        find('[data-cf-guide-message]').textContent=message;
        find('[data-cf-guide-progress]').style.width=((state.step+1)/3*100)+'%';
      }
      const buy=find('[data-cf-buy]');buy.hidden=quoteOnly();buy.disabled=busy || !variant()?.available;
      find('[data-cf-quote]').hidden=!quoteOnly();
    }
    function changed() {
      changeVersion++;
      if(state.submitted) {state.submitted=null;state.id=uid();find('[data-cf-result]').hidden=true;}
      status('');render();save();
    }
    function showStep(step,focus=true) {
      state.step=step;
      for(const panel of root.querySelectorAll('[data-panel]')) panel.hidden=Number(panel.dataset.panel) !== step;
      for(const btn of root.querySelectorAll('[data-step]')) {if(Number(btn.dataset.step) === step) btn.setAttribute('aria-current','step');else btn.removeAttribute('aria-current');}
      render();save();
      if(focus && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        find('[data-cf-guide]')?.animate([{opacity:.5,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'ease-out'});
        if(step === 2) {
          const sparks=document.createElement('div');sparks.className='cf-creation-sparks';sparks.setAttribute('aria-hidden','true');
          for(let i=0;i<7;i++) {const spark=document.createElement('i');spark.style.setProperty('--i',String(i));sparks.append(spark);}
          find('[data-cf-guide]').append(sparks);setTimeout(()=>sparks.remove(),900);
        }
      }
      if(focus) {
        const panel=find('[data-panel="'+step+'"]');
        const target=panel.querySelector('h3') || panel.querySelector('input');target.focus({preventScroll:true});
        form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      }
    }
    function invalid(el) {el.setAttribute('aria-invalid','true');el.focus();status(t.field_error);return false;}
    function validate(step) {
      for(const input of form.querySelectorAll('[aria-invalid]')) input.removeAttribute('aria-invalid');
      if (step === 0) {
        if(state.size === 'otro' && !state.custom_size.trim()) return invalid(form.elements.custom_size);
        if(state.base === 'con' && !shared() && !state.base_name.trim()) return invalid(form.elements.base_name);
      }
      if(step === 1) {
        const min=cfg.line === 'persona' && state.format !== 'busto' ? 3 : 2;
        if(!state.photos_later && state.photos.length < min) {status(t.photos_missing);find('[data-cf-files]').focus();return false;}
      }
      if(step === 2) {
        if(!state.contact.trim()) return invalid(form.elements.contact);
        if(state.phone.replace(/\D/g,'').length < 8) return invalid(form.elements.phone);
        if(!state.consent) return invalid(form.elements.consent);
      }
      return true;
    }
    function lock(value) {
      busy=value;
      for(const btn of root.querySelectorAll('.cf-form button')) btn.disabled=value;
      for(const input of form.querySelectorAll('input,textarea')) input.disabled=value;
      render();
    }
    function result(message,links) {
      const wrap=find('[data-cf-result]');wrap.hidden=false;wrap.replaceChildren();
      const p=document.createElement('p');p.textContent=message;wrap.append(p);
      for(const [label,url] of links) {const a=document.createElement('a');a.className='cf-button cf-button-outline';a.textContent=label;a.href=url;if(url.startsWith('https://wa.me/')) {a.target='_blank';a.rel='noopener';}wrap.append(a);}
      wrap.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'nearest'});
    }
    function whatsappUrl(saved) {
      const note=saved ? 'Las fotos adjuntas ya están en mi solicitud.' : 'Adjuntaré mis fotos en esta conversación.';
      return 'https://wa.me/'+cfg.whatsapp+'?text='+encodeURIComponent('Hola Crealis! Quiero preparar esta figura.\n\n'+summary()+'\n\n'+note+'\nQuiero coordinar el precio, la fecha y la revisión del modelo.');
    }
    async function preparePhoto(file) {
      if(!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size>15*1024*1024) throw new Error('file');
      const blobUrl=URL.createObjectURL(file);
      try {
        const img=new Image();img.src=blobUrl;await img.decode();
        const factor=Math.min(1,900/Math.max(img.width,img.height));
        const canvas=document.createElement('canvas');canvas.width=Math.round(img.width*factor);canvas.height=Math.round(img.height*factor);
        const ctx=canvas.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.drawImage(img,0,0,canvas.width,canvas.height);
        let quality=.82,data=canvas.toDataURL('image/jpeg',quality);
        while(data.length>210000 && quality>.35) {quality-=.1;data=canvas.toDataURL('image/jpeg',quality);}
        if(data.length>220000) throw new Error('large');
        return {name:file.name.slice(0,90),data};
      } finally {URL.revokeObjectURL(blobUrl);}
    }
    async function sendHub() {
      if(state.submitted?.channel === 'whatsapp') return true;
      if(!cfg.hubKey) throw new Error('No hub');
      const text=value=>({stringValue:String(value)});
      const fields={producto:text(cfg.line === 'mascota' ? 'Figura personalizada de mascota' : 'Figura personalizada de persona'),respuestas:text(summary()),estimado:text(actualPrice() ? money(actualPrice()) : t.quote_value),contacto_nombre:text(state.contact),contacto_tel:text(state.phone),contacto_ig:text(''),contacto_mail:text(''),canal:text('WhatsApp'),referencias:text('Fotografías de encargo '+state.id),archivos:text(state.photos_later ? t.photo_pending : 'No'),imagenes:{arrayValue:{values:state.photos.map(p=>text(p.data))}},estado:text('nueva'),origen:text('web'),ts:{integerValue:String(Date.now())}};
      const response=await fetch('https://firestore.googleapis.com/v1/projects/'+cfg.hubProject+'/databases/(default)/documents/solicitudes?documentId='+encodeURIComponent(state.id)+'&key='+encodeURIComponent(cfg.hubKey),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({fields}),signal:AbortSignal.timeout(20000)});
      if(!response.ok) throw new Error('Hub '+response.status);
      state.submitted={channel:'whatsapp'};await save();return true;
    }
    async function addCart() {
      const v=variant(); if(!v?.available) throw new Error('Variant unavailable');
      const existingResponse=await fetch(cfg.cart+'.js',{signal:AbortSignal.timeout(15000)});
      if(!existingResponse.ok) throw new Error('Cart unavailable');
      const existing=await existingResponse.json();
      if(existing.items.some(item=>item.properties?.Encargo === state.id)) return;
      const body=new FormData();body.append('id',v.id);body.append('quantity','1');
      const properties={Encargo:state.id,'Nombre en base':state.base === 'con' || shared() ? state.base_name : '',[cfg.line === 'mascota' ? 'Nombre de la mascota' : 'Nombre de la persona']:state.subject,Detalles:state.details,'Fecha deseada (a confirmar)':state.date,'_Contacto del encargo':state.contact,_WhatsApp:state.phone,_Acabado:t.white,'Revisión del modelo':t.approval,'Fotografías':state.photos_later ? t.photo_pending : state.photos.length+' adjuntas','_Autorización de fotos':'Solo para preparar el encargo; no autoriza publicación'};
      for(const [key,value] of Object.entries(properties)) if(value) body.append('properties['+key+']',value);
      for(let i=0;i<state.photos.length;i++) {
        const bin=atob(state.photos[i].data.split(',')[1]),bytes=Uint8Array.from(bin,c=>c.charCodeAt(0));
        body.append('properties[Foto '+(i+1)+']',new Blob([bytes],{type:'image/jpeg'}),'referencia-'+(i+1)+'.jpg');
      }
      const response=await fetch(cfg.cartAdd,{method:'POST',body,signal:AbortSignal.timeout(30000)});
      if(!response.ok) throw new Error('Cart '+response.status);
      const item=await response.json();
      if(item.properties?.Encargo !== state.id || state.photos.some((_,i)=>!String(item.properties?.['Foto '+(i+1)]||'').includes('/uploads/'))) throw new Error('Missing properties');
      state.submitted={channel:'shopify'};await save();
    }
    async function submit(channel) {
      if(busy || processing || !validate(0) || !validate(1) || !validate(2)) return;
      if(channel === 'shopify' && quoteOnly()) return;
      lock(true);status(t.sending);await saveChain;
      try {
        if(channel === 'shopify') {
          await addCart();result(t.cart_success,[[t.cart_open,cfg.cart],[t.open_whatsapp,whatsappUrl(false)]]);
        } else {
          await sendHub();result(t.hub_success,[[t.open_whatsapp,whatsappUrl(true)]]);
        }
        status('');
      } catch(error) {
        result(channel === 'shopify' ? t.cart_error : t.hub_error,[[t.open_whatsapp,whatsappUrl(false)]]);
        status(channel === 'shopify' ? t.cart_error : t.hub_error);
      } finally {lock(false);}
    }
    form.addEventListener('submit',event=>event.preventDefault());
    form.addEventListener('input',event => {
      const el=event.target;
      if(fields.includes(el.name)) {
        const previous=state[el.name];
        state[el.name]=el.value;
        if(cfg.line === 'mascota' && el.name === 'base_name' && (!state.subject || state.subject === previous)) {state.subject=el.value;form.elements.subject.value=el.value;}
        changed();
      }
    });
    form.addEventListener('change',event => {
      const el=event.target;
      if(['format','size','base'].includes(el.name)) {
        state[el.name]=el.value;
        if(el.name === 'format') {state.size=sizes()[0];state.base='sin';renderSizes();syncInputs();}
        changed();
        if(!matchMedia('(prefers-reduced-motion: reduce)').matches) find('[data-cf-preview]').animate([{transform:'scale(.97)'},{transform:'scale(1)'}],{duration:220,easing:'ease-out'});
      } else if(['photos_later','special','consent'].includes(el.name)) {state[el.name]=el.checked;changed();}
    });
    find('[data-cf-files]').addEventListener('change',async event => {
      if(processing || busy) return;processing=true;status(t.preparing_photos);
      const input=event.target;const files=Array.from(input.files);input.disabled=true;
      let error='';
      for(const file of files) {
        if(state.photos.length>=3) {error=t.file_limit;break;}
        try {state.photos.push(await preparePhoto(file));} catch(e) {error=t.file_error;}
      }
      state.photos_later=false;form.elements.photos_later.checked=false;
      input.value='';input.disabled=false;processing=false;changed();renderPhotos();status(error);await save();
    });
    root.querySelectorAll('[data-next]').forEach(btn=>btn.addEventListener('click',()=>{if(!processing && validate(state.step)) showStep(state.step+1);}));
    root.querySelectorAll('[data-back]').forEach(btn=>btn.addEventListener('click',()=>showStep(Math.max(0,state.step-1))));
    root.querySelectorAll('[data-step]').forEach(btn=>btn.addEventListener('click',()=>{
      const step=Number(btn.dataset.step);
      if(processing) return;
      if(step<state.step || Array.from({length:step},(_,i)=>i).every(validate)) showStep(step);
    }));
    find('[data-cf-buy]').addEventListener('click',()=>submit('shopify'));
    find('[data-cf-wa]').addEventListener('click',()=>submit('whatsapp'));
    find('[data-cf-download]').addEventListener('click',()=>{
      const blob=new Blob([summary()],{type:'text/plain;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=state.id+'.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),2000);
    });
    find('[data-cf-clear]').addEventListener('click',async()=>{
      if(busy || processing || !confirm(t.clear_confirm)) return;
      state=defaults();syncInputs();renderSizes();renderPhotos();find('[data-cf-result]').hidden=true;showStep(0,false);status('');await save();
    });
    try {
      const restored=await readDraft();
      if(restored && restored.updated>Date.now()-7*24*60*60*1000) {state={...state,...restored};status(t.restored);}
    } catch(error) {status(t.save_error);}
    syncInputs();renderSizes();renderPhotos();find('[data-cf-workspace]').hidden=false;showStep(Math.min(2,Math.max(0,state.step)),false);
    const requestedVariant=new URLSearchParams(location.search).get('variant');
    const chosen=cfg.product?.variants?.find(v=>String(v.id) === requestedVariant);
    if(chosen) {
      state.format=cfg.line === 'mascota' ? 'mascota' : chosen.option1.startsWith('Busto') ? 'busto' : chosen.option1.startsWith('Pareja') ? 'pareja' : 'completo';
      state.size=chosen.option1.match(/\d+/)?.[0] || sizes()[0];state.base=chosen.option2 === 'Con base y nombre' ? 'con' : 'sin';
      syncInputs();renderSizes();render();save();
    }
  };
  document.querySelectorAll('[data-figuras]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-figuras]').forEach(init));
})();
